/*
 * @Author: lifei
 * @Date: 2021-07-We 03:18:22
 * @Last Modified by: lifei
 * @Last Modified time: 2021-07-We 03:18:22
 */
import { cloneDeep } from 'lodash';
import Stores from 'config/Stores';

/**
 * 获得有权限点的路由
 *
 * @export
 * @param {Array} routeList 路由
 * @param {Array} authList 权限点
 * @return {Array} cloneRouter 过滤后的路由集合
 */
export function getAuthRouteList(routeList = [], authList = []) {
  const cloneRouter = cloneDeep(routeList);
  //处理权限问题
  for (let i = 0; i < cloneRouter.length; i++) {
    const currentRoute = cloneRouter[i];
    if (currentRoute.authCode) {
      const authCodeIndex = authList.findIndex((item) => item === currentRoute.authCode);
      if (authCodeIndex <= -1) {
        //说明没有权限要干掉这一项
        cloneRouter.splice(i, 1);
        i--;
      }
    }
  }

  return cloneRouter;
}

/**
 * 是否有某个页面的权限
 *
 * @export
 * @param {string} authCode
 */
export function isHasRouteAuth(authCode = '') {
  const routeAuthList = Stores.AppMod.authList || [];
  return routeAuthList.some((item) => item === authCode);
}

/**
 * 是否有某个标签的权限
 *
 * @export
 * @param {string} authCode
 */
export function isHasTagAuth(authCode = '') {
  const tagAuthList = Stores.AppMod.tagAuthList || [];
  return tagAuthList.some((item) => item === authCode);
}

/**
 * 获取标签的值
 *
 * @export
 * @param {string} authCode
 */
export function filterHasTagAuth(authCode = '') {
  const tagAuthList = Stores.AppMod.tagAuthList || [];
  return tagAuthList.filter((item) => item === authCode);
}

/**
 * xls-新站点开通预计收益
 *
 * @export
 */
export function xlsSites(belongSystem = '') {
  return [
    'WDY',
    'YC',
    'XMD',
    'TH',
    'JCH',
    'DKG',
    'YUY',
    'LSH',
    'CXY',
    'SC',
    'YBY',
    'HS',
    'XBL',
    'XDE',
    'MT'
  ].includes(belongSystem);
}



// WEBPACK FOOTER //
// ./src/utils/authUtil.js